import { useTranslation } from "react-i18next";
import { MessagePlatformList } from "./MessagePlatformList";
import {StyledMessagePlatform} from "./MessagePlatform.styled";
import { PageTitle } from '../../common/PageTitle';


export function MessagePlatform ({ match }) {
    const { buildingID } = match.params;
    const { t } = useTranslation();

    return (
        <StyledMessagePlatform className="bllink-text">
            <PageTitle text={t('messagePlatform.titles.messagePlatform')}/>
            <MessagePlatformList buildingID={buildingID}/>
        </StyledMessagePlatform>
    );
}
